<template>
    <div class="threat-summary-container">
        <h4 class="summary-title">SUMMARY OF {{title.toUpperCase()}} DATA</h4>
        <table>
            <thead>
            <tr>
                <th v-if="summaryRequestParams.showListedRow" style="width: 100px; background-color: black"></th>
                <th align="center"
                    :class="{'active-summary-element':summarySelectedState === null, 'clickable-column':isDataTableVisible && ((summaryRequestParams.showListedRow && summaryStatistics.unresolved_total_count) || !summaryRequestParams.showListedRow && summaryStatistics.total_count)}"
                    @click="itemClicked(null, summaryRequestParams.showListedRow ? summaryStatistics.unresolved_total_count : summaryStatistics.total_count)">
                    All Records
                </th>
                <th align="center"
                    :class="{'active-summary-element':summarySelectedState === 4, 'clickable-column':isDataTableVisible && ((summaryRequestParams.showListedRow && summaryStatistics.unresolved_last_year) || !summaryRequestParams.showListedRow && summaryStatistics.last_year)}"
                    @click="itemClicked(4, summaryRequestParams.showListedRow ? summaryStatistics.unresolved_last_year : summaryStatistics.last_year)">Last 365 Days
                </th>
                <th align="center"
                    :class="{'active-summary-element':summarySelectedState === 3, 'clickable-column':isDataTableVisible && ((summaryRequestParams.showListedRow && summaryStatistics.unresolved_last_month) || !summaryRequestParams.showListedRow && summaryStatistics.last_month)}"
                    @click="itemClicked(3, summaryRequestParams.showListedRow ? summaryStatistics.unresolved_last_month : summaryStatistics.last_month)">Last 30 Days
                </th>
                <th align="center"
                    :class="{'active-summary-element':summarySelectedState === 2, 'clickable-column':isDataTableVisible && ((summaryRequestParams.showListedRow && summaryStatistics.unresolved_last_week) || !summaryRequestParams.showListedRow && summaryStatistics.last_week)}"
                    @click="itemClicked(2, summaryRequestParams.showListedRow ? summaryStatistics.unresolved_last_week : summaryStatistics.last_week)">Last 7 Days
                </th>
                <th align="center"
                    :class="{'active-summary-element':summarySelectedState === 1, 'clickable-column':isDataTableVisible && ((summaryRequestParams.showListedRow && summaryStatistics.unresolved_last_day) || !summaryRequestParams.showListedRow && summaryStatistics.last_day)}"
                    @click="itemClicked(1, summaryRequestParams.showListedRow ? summaryStatistics.unresolved_last_day : summaryStatistics.last_day)">Last 24 Hours
                </th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td v-if="summaryRequestParams.showListedRow" class="row-label">All</td>
                <td>
                    {{summaryStatistics.total_count}}
                </td>
                <td>
                    {{summaryStatistics.last_year}}
                </td>
                <td>
                    {{summaryStatistics.last_month}}
                </td>
                <td>
                    {{summaryStatistics.last_week}}
                </td>
                <td>
                    {{summaryStatistics.last_day}}
                </td>
            </tr>
            <tr v-if="summaryRequestParams.showListedRow">
                <td class="row-label">Listed <img src="../../assets/questions-circular-button.png" alt="info"
                                                  @mouseover="onMouseOverHelp($event)" @mouseout="onMouseOutHelp()"/>
                </td>
                <td :class="{'active-summary-element':summarySelectedState === null}">
                    {{summaryStatistics.unresolved_total_count}}
                </td>
                <td :class="{'active-summary-element':summarySelectedState === 4}">
                    {{summaryStatistics.unresolved_last_year}}
                </td>
                <td :class="{'active-summary-element':summarySelectedState === 3}">
                    {{summaryStatistics.unresolved_last_month}}
                </td>
                <td :class="{'active-summary-element':summarySelectedState === 2}">
                    {{summaryStatistics.unresolved_last_week}}
                </td>
                <td :class="{'active-summary-element':summarySelectedState === 1}">
                    {{summaryStatistics.unresolved_last_day}}
                </td>
            </tr>
            </tbody>
        </table>
        <global-tooltip ref="globalTooltip"></global-tooltip>
    </div>
</template>

<script>
    import GlobalTooltip from '@/components/tooltip/GlobalTooltip.vue';

    export default {
        name: "threat-summary",
        components: {
            GlobalTooltip: GlobalTooltip
        },
        props: {
            summaryRequestParams: {
                type: Object,
                required: false
            },
            summaryStatistics: {
                type: Object,
                required: false
            },
            title: {
                type: String,
                required: false
            },
            summarySelectedState: {
                type: Number,
                required: false
            },
            isDataTableVisible: {
                type: Boolean,
                required: false
            },
            summaryItemClicked: {
                type: Function,
                required: false
            },
            isStolen: {
                type: Boolean,
                required: false
            }
        },
        methods: {
            onMouseOverHelp(e) {
                var self = this;
                var rect = e.target.getBoundingClientRect();
                self.$refs.globalTooltip.showTooltip(rect.top + 25, rect.left, 'Indicates the threats resolved in the last 30 days and unresolved threats');
            },
            onMouseOutHelp() {
                this.$refs.globalTooltip.hideTooltip();
            },
            itemClicked(summaryEnum, summaryCount) {
                if (summaryCount)
                    this.$emit("summaryItemClicked", summaryEnum)
            }
        },
        beforeMount() {

        }
    }
</script>

<style scoped>
    .threat-summary-container {
        width: 100%;
        font-family: 'Digital-Serial-Bold';
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .threat-summary-container table {
        width: 70%;
        margin-bottom: 24px;
        font-weight: bolder;
    }

    .threat-summary-container thead {
        background-color: #374453;
    }

    .row-label {
        width: 100px;
        background-color: #374453;
    }

    .row-label img {
        padding-left: 4px;
    }

    .threat-summary-container th, td {
        border-right: 1px solid black;
        text-align: center !important;
    }


    .clickable-column {
        cursor: pointer;
    }

    .threat-summary-container tr {
        height: 40px;
        border-bottom: 2px solid black;
    }

    .active-summary-element {
        color: #FFD137;
    }

    .summary-title {
        font-weight: bolder;
    }

</style>



// WEBPACK FOOTER //
// src/components/threat-summary/ThreatSummary.vue